$(function(){
    $('.js-auth-social').on('click', function () {
        if (conversionDeferredEvent.isSetConversion()) {
            conversionDeferredEvent.triggerEvent();
        }

        window.location.href = $(this).data('social-url')+"?_destination="+URL_CONST.LOGIN_REDIRECT;
    });
});
